<template>
  <div :class="isMobile?'lw-y-banner-template-mobile':'lw-y-banner-template'">
    <div class="header-box">
      <div class="login-banner">
        <div :class="nonsupportUiCustom ?'login-banner-bg-fixed' : 'login-banner-bg-ui-custom'" ref="header"/>
        <div class="login-banner-info" >
          <el-image v-if="logSrc" class="logo" ref="logo" :src="logSrc" :key="logSrc" @load="load" @error="error">
            <div class="error_image" style="width:180px;height:160px;" slot="error">
              左上角Logo图
            </div>
          </el-image>
          <el-image v-if="!isMobile && bannerSrc" ref="banner" class="cente" :src="bannerSrc">
            <div class="error_image" style="width:100%;height:100%;" slot="error">
              左上角Logo图下方的banner图
            </div>
          </el-image>
          <div class="right">
            <slot name="userInfo"></slot>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import fileService from '@/services/file.service'
import {getUIConfig} from '@/services/uiConfig.service'
import { UiConfigModule } from '../../store/modules/uiConfig'
export default {
  name: "CommonBannerComponent",
  props: {
    /**
     * 暂时不支持UI自定义标志位
     *
     */
    nonsupportUiCustom: {
      type: Boolean,
      default: false
    },
    functionModule: {
      type: String,
      default: ''
    },
    userType: {
      type: String,
      default: ''
    },
    functionClient: {
      type: String,
      default: ''
    },
    /**
     * 用户所属的园区Id，默认为null
     * 根据不用的园区Id，会展示不同园区的UI自定义内容。 如果为空，则加载公共的配置信息。
     * 园区Id是否为空的判断，会在userType之前。
     */
    gardenId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      positionLeft: 0,
      logSrc: '',//UI自定义时改为空
      bannerSrc: ''//UI自定义时该为空
    };
  },

  async mounted() {
    if (this.nonsupportUiCustom) {
      this.logSrc = require('../../assets/images/log2.png')
      this.bannerSrc = require('../../assets/images/sologan.png')
      document.title = '优课场域—不只有一支马良笔'
    } else {
      await this.initUI()
    }
  },
  methods: {
    // logo加载完毕
    load(){
      const width = this.$refs.logo.imageWidth + 20
      if (this.$refs.banner) {
        this.$refs.banner.$el.style.width=`calc(100% - ${width}px)`
        this.$refs.banner.$el.style.marginLeft = `${width}px`
      }

    },
    // logo加载出错
    error(){
      if (this.$refs.banner) {
        this.$refs.banner.$el.style.width = `calc(100% - 200px)`
        this.$refs.banner.$el.style.marginLeft = '200px'
      }
    },
    // 初始化UI
    async initUI() {
      const query = {
        gardenId: this.gardenId,
        userType:'all',
        functionClient:'all',
        functionModule:'all'
      }
      await getUIConfig(query).then(res => {
        if(res) {
          if(res['all_all_all_footer']) {
            UiConfigModule.setFooter(res['all_all_all_footer'].footer)
          }
          // 设置浏览器选项卡
          if(res['all_all_all_browser_tab']  && res['all_all_all_browser_tab'].browserTab){
            if(res['all_all_all_browser_tab'].browserTab.iconUrl){
              const tabUrl = fileService.showPic(res['all_all_all_browser_tab'].browserTab.iconUrl)
              document.querySelector('link[rel*="icon"]').href = tabUrl
            } else {
              document.querySelector('link[rel*="icon"]').href = require('../../../public/default.png')
            }
            document.title = res['all_all_all_browser_tab'].browserTab.tittle
          } else {
            document.querySelector('link[rel*="icon"]').href = require('../../../public/default.png')
            document.title = ''
          }
        }
      })
      const header = this.$refs.header
      // 清空顶部横图UI样式
      header.innerHTML = ""
      // 已选择完园区加载对应园区UI配置
      const param = {
        gardenId: this.gardenId,
        userType: this.userType,
        functionClient: this.functionClient,
        functionModule: this.functionModule
      }
      await getUIConfig(param).then(res => {
        if(res){
          this.uiConfig = res
        }
      })

      if(!this.uiConfig){
        return
      }
      const key = `${this.userType}_${this.functionClient}_${this.functionModule}`
      // 设置banner
      if(this.uiConfig[`${key}_banner`] && this.uiConfig[`${key}_banner`].picture !== 'unset'){
        this.bannerSrc = fileService.showPic(this.uiConfig[`${key}_banner`].picture)
      } else {
        this.bannerSrc = ''
      }

      // 设置logo
      if(this.uiConfig[`${key}_logo`] && this.uiConfig[`${key}_logo`].picture !== 'unset'){
        this.logSrc = fileService.showPic(this.uiConfig[`${key}_logo`].picture)
      } else {
        this.logSrc = ''
      }

      // 设置顶部横图
      if(this.uiConfig[`${key}_background`]){
        this.uiConfig[`${key}_background`].background.forEach(element => {
          const div = document.createElement('div')
          if (element.customContentValueType === 'color') {
              div.className = element.customContentLayoutType === 'browser_width' ? 'browser-width-entry' : 'main-width-entry'
              div.style = `background-color:${element.customContentValue};z-index:${element.zindex};`
          } else {
              if(element.customContentValue === 'unset'){
                return
              }
              let style = `background-image: url('${fileService.showPic(element.customContentValue)}');z-index:${element.zindex};`
              switch (element.customContentLayoutType) {
                  case 'browser_repeat':
                  case 'main_content_repeat':
                      style += 'background-repeat: repeat;'
                      break
                  case 'browser_center':
                      style += 'background-repeat: no-repeat;background-position: center;'
                      break
                  case 'browser_left':
                  case 'main_content_left':
                      style += 'background-repeat: no-repeat;background-position: left center;'
                      break
                  case 'browser_right':
                  case 'main_content_right':
                      style += 'background-repeat: no-repeat;background-position: right center;'
                      break
                  case 'browser_stretch':
                  case 'main_content_stretch':
                      style += 'background-repeat: no-repeat;background-size: 100% 100%;'
                      break
                  case 'browser_cover':
                  case 'main_content_cover':
                    style += 'background-repeat: no-repeat;background-size: cover;background-position:50%;'
                    break
              }
              div.className = element.customContentLayoutType.indexOf('browser') !== -1 ? 'browser-width-entry' : 'main-width-entry'
              div.style = style
          }
          header.appendChild(div)
        })
      }

      // 设置顶部横图
      if(this.uiConfig[`${key}_module_name`]){
        UiConfigModule.setModuleName(this.uiConfig[`${key}_module_name`].footer)
      }

    }
  }
};
</script>
<style lang="scss">
.garden-success {
  top: 15vh !important;
}
.browser-width-entry {
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
}
.main-width-entry {
  position: absolute;
  top: 0px;
  @media screen and (min-width: 1366px){
    width: 1366px;
    left: calc((100% - 1366px) / 2);
  }
  @media screen and (min-width: 1000px) and (max-width: 1366px) {
    width: 1020px;
    left: calc((100% - 1020px) / 2);
  }
  @media screen and (max-width: 1000px) {
    width: 1020px;
  }
  height: 100%;
}
</style>
<style scoped lang="scss">
@import "../../assets/scss/index";

@-webkit-keyframes popIn {
  0% {
    -webkit-transform: scale3d(0, 0, 0);
    transform: scale3d(0.5, 0.5, 0.5);
    opacity: 0;
  }
  50% {
    -webkit-animation-timing-function: cubic-bezier(0.47, 0, 0.745, 0.715);
    animation-timing-function: cubic-bezier(0.47, 0, 0.745, 0.715);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
    -webkit-animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
    animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
    opacity: 1;
  }
}

@keyframes popIn {
  0% {
    -webkit-transform: scale3d(0, 0, 0);
    transform: scale3d(0.5, 0.5, 0.5);
    opacity: 0;
  }
  50% {
    -webkit-animation-timing-function: cubic-bezier(0.47, 0, 0.745, 0.715);
    animation-timing-function: cubic-bezier(0.47, 0, 0.745, 0.715);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
    -webkit-animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
    animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
    opacity: 1;
  }
}

/*@import "./_lwTopBanner.scss";*/


@mixin scroll-bar($width: 6px, $height: 6px, $borderRadius: 2px) {
  &::-webkit-scrollbar-track {
    border-radius: $borderRadius;
    background-color: #ffffff;
  }
  &::-webkit-scrollbar {
    width: $width;
    height: $height;
    background-color: #ffffff;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: $borderRadius;
    background-color: rgba(0, 0, 0, 0.2);
  }
}


.lw-y-banner-template {
  .header-box {
    width: calc(100vw - 6px);
    position: relative;
    height: computer(200px);
    /*border: 1px solid red;*/
    .login-banner{
      position: absolute;
      width: 100%;
      height: 200px;
      .login-banner-bg-ui-custom{

        position: absolute;
        height: 100%;
        width: 100%;
        background-color: #f8f8f8;
      }
      .login-banner-bg-fixed{

        position: absolute;
        height: 100%;
        width: 100%;
        background: url("../../assets/images/background.png") no-repeat;
        background-size: cover;
      }

      .login-banner-info{
        position: absolute;
        height: 200px;
        z-index: 998;
        @media screen and (min-width: 1366px){
          width: 1366px;
          left: calc((100% - 1366px) / 2);
        }
        @media screen and (min-width: 1000px) and (max-width: 1366px) {
          width: 1020px;
          left: calc((100% - 1020px) / 2);
        }
        @media screen and (max-width: 1000px) {
          width: 1020px;
        }


        .logo {
          position: absolute;
          max-height: 160px;
          max-width: 180px;
          top: 20px;
          left: 0px;
          z-index: 998;
        }

        .cente {
          margin-top: 50px;
          margin-left: 0px;
          width: 100%;
          height: 123px;
          overflow: hidden;
          text-align: left;
          ::v-deep .el-image__inner{
            width: unset;
            height: unset;
          }
        }

        .right {
          position: absolute;
          top: 20px;
          right: 0px;
          z-index: 998;
        }
      }
    }
  }
}

.lw-y-banner-template-mobile {
  .header-box {
    width: 100vw;
    position: relative;
    height: 100px;
    .login-banner{
      width: 100vw;
      position: relative;
      height: 100px;
      .login-banner-bg-ui-custom{
        position: absolute;
        height: 100%;
        width: 100vw;
        z-index: 899;
        background-color: #f8f8f8;
      }
      .login-banner-bg-fixed{
        position: absolute;
        height: 100%;
        width: 100vw;
        z-index: 899;
        background: url("../../assets/images/background.png") no-repeat;
        background-size: cover;
      }
      .login-banner-info{
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 1000;
        display: flex;
        align-items: center;

        .logo {
          margin-left: 20px;
          float: left;
          ::v-deep img{
            max-height: 100px;
            max-width: calc(100vw - 175px);
            width: auto;
            height: auto;
          }
        }

        .right {
          position: absolute;
          top: 20px;
          right: 20px;
          z-index: 1000;
        }
      }
    }
  }
}
</style>
